import IFileUpload from '../interfaces/IFileUpload';

const fileUpload = (): IFileUpload => ({
  blob: '',
  url: '',
  keys: [],
});

export default fileUpload;
